require('prismjs/themes/prism-tomorrow.css')
// trigger an immediate page refresh when an update is found
export const onServiceWorkerUpdateReady = () => window.location.reload()
